import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/levellevel.webp';
import screenshot_target from '../../../images/letterfunnel/nielsdeblaauw.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Niels de Blaauw"
      firstname="Niels"
      companyname="Level Level"
      competition="Van Ons en Human Made"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/nielsdeblaauw.js